(() => {

  'use strict';

  const $ = (s, r=document) => r.querySelector(s), $$ = (s, r=document) => [...r.querySelectorAll(s)];

  const config = JSON.parse($('#LumaConfig')?.textContent || '{}');

  const root = (config.root || '/').replace(/\/?$/, '/');

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  const motion = () => !reduced.matches && document.body.dataset.motion !== 'false';

  const money = cents => new Intl.NumberFormat(config.locale || 'en', { style:'currency',currency:config.currency || 'EUR' }).format(cents/100);

  const dialog = $('[data-cart-dialog]');

  const events = new AbortController(), signal = events.signal;

  let cartBusy=false, toastTimer, scrollFrame=0;

  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const safeImage = value => {try {const u=new URL(value,location.origin);return u.protocol==='https:'?u.href:'';} catch{return '';}};

  async function api(path,body) {

    const response=await fetch(root+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined});

    const result=await response.json();if(!response.ok)throw Error(result.description || result.message || config.error);return result;

  }

  function toast(message){const t=$('.toast');t.textContent=message;t.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>t.hidden=true,2400);}

  function modalState(){document.body.classList.toggle('modal-open',!!$('dialog[open]'));}

  const rewardCopy=JSON.parse($('#FelleruhRewardsConfig')?.textContent||'{}');
  const rewardTier=cart=>Number(cart.items_subtotal_price)>10000?10:Number(cart.items_subtotal_price)>5000?5:0;
  const rewardCode=cart=>rewardTier(cart)===10?rewardCopy.ten:rewardTier(cart)===5?rewardCopy.five:'';
  function renderRewards(cart){
    const subtotal=Number(cart.items_subtotal_price),tier=rewardTier(cart);
    $$('[data-bag-rewards]').forEach(el=>{
      el.style.setProperty('--reward-progress',Math.min(100,subtotal/10001*100)+'%');
      $('[data-reward-status]',el).textContent=tier?rewardCopy.unlocked.replace('__PERCENT__',tier):subtotal>0?rewardCopy.shipping:rewardCopy.heading;
      $('[data-reward-next]',el).textContent=tier===10?rewardCopy.checkout:subtotal>0?rewardCopy.next.replace('__AMOUNT__',money((tier===5?10001:5001)-subtotal)).replace('__PERCENT__',tier===5?10:5):rewardCopy.everyOrder;
      $$('[data-reward-dot],[data-reward-label]',el).forEach(item=>item.classList.toggle('is-unlocked',subtotal>0&&Number(item.dataset.rewardDot??item.dataset.rewardLabel)<=tier));
    });
    $$('[data-tier-discount]').forEach(input=>input.value=rewardCode(cart));
  }
  function renderCart(cart) {
    renderRewards(cart);

    $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);

    $('[data-cart-total]').textContent=money(cart.total_price);

    const target=$('[data-cart-items]');target.replaceChildren();

    if(!cart.items.length){const p=document.createElement('p');p.textContent=config.empty;target.append(p);}

    for(const item of cart.items){

      const light=item.product_id===Number(config.productId),img=safeImage(item.image);

      const node=document.createElement('article');node.className='cart-line';

      node.innerHTML=`${img?`<img src="${escapeHTML(img)}" width="80" height="95" alt="${escapeHTML(item.variant_title || item.title)}">`:'<span></span>'}<div><h3>${escapeHTML(light?config.name:item.product_title)}</h3><p>${escapeHTML(item.variant_title)}</p><p>${escapeHTML(money(item.final_line_price))}</p><div class="cart-line-controls"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}" aria-label="${escapeHTML(config.decrease)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${item.quantity+1}" aria-label="${escapeHTML(config.increase)}">+</button><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="0">${escapeHTML(config.remove)}</button></div></div>`;

      target.append(node);

    }

    $('[name=checkout]',dialog).disabled=!cart.items.length;

  }

  async function openCart(){

    if(!dialog.open)dialog.showModal();modalState();

    const error=$('.cart-error',dialog);error.hidden=true;

    try{renderCart(await api('cart.js'));}catch(e){error.textContent=e.message;error.hidden=false;}

  }

  document.addEventListener('click',async event=>{

    const open=event.target.closest('[data-cart-open]');if(open){event.preventDefault();openCart();return;}

    if(event.target.closest('[data-cart-close]')){dialog.close();return;}

    const change=event.target.closest('[data-cart-change]');if(change&&!cartBusy){

      cartBusy=true;$$('[data-cart-change]',dialog).forEach(el=>el.disabled=true);

      try{renderCart(await api('cart/change.js',{id:change.dataset.cartChange,quantity:Number(change.dataset.quantity)}));}

      catch(e){const error=$('.cart-error',dialog);error.textContent=e.message;error.hidden=false;}

      finally{cartBusy=false;$$('[data-cart-change]',dialog).forEach(el=>el.disabled=false);}

    }

    const reviewLink=event.target.closest('a[href^="#ReviewForm-"]');if(reviewLink){const form=document.getElementById(reviewLink.getAttribute('href').slice(1));if(form)form.open=true;}

    if(event.target.closest('[data-cookie-preferences]')){

      if(window.Shopify?.customerPrivacy?.showPreferences)window.Shopify.customerPrivacy.showPreferences();

      else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>window.Shopify.customerPrivacy?.showPreferences?.());

    }

  },{signal});

  dialog.addEventListener('close',modalState,{signal});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},{signal});

  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-tier-checkout]');
    if(!form||event.submitter?.name!=='checkout'||form.dataset.tierReady==='true')return;
    event.preventDefault();
    if(form.dataset.tierBusy==='true')return;
    form.dataset.tierBusy='true';const button=event.submitter;button.disabled=true;
    const error=$('.cart-error',dialog);error.hidden=true;
    try{
      const quantities=$$('input[name="updates[]"]',form);
      let cart=quantities.length?await api('cart/update.js',{updates:quantities.map(input=>Number(input.value))}):await api('cart.js');
      cart=await api('cart/update.js',{discount:rewardCode(cart)});
      renderCart(cart);
      form.dataset.tierReady='true';button.disabled=false;form.requestSubmit(button);delete form.dataset.tierReady;
    }catch(e){error.textContent=e.message;error.hidden=false;if(!dialog.open){dialog.showModal();modalState();}}
    finally{form.dataset.tierBusy='false';button.disabled=false;}
  },{signal});
  function initPanel(panel) {

    if(panel.dataset.initialized)return;panel.dataset.initialized='true';

    const variants=JSON.parse($('[data-variants]',panel)?.textContent||'[]');if(!variants.length)return;

    const c=JSON.parse($('[data-product-copy]',panel).textContent),select=$('[data-variant]',panel),form=$('form.product-form',panel),grid=$('[data-variant-grid]',panel),image=$('.purchase-image-wrap img',panel),zoom=$('.zoom-dialog',panel),mobile=$('.mobile-buy',panel);

    const life=new AbortController();panel.lumaCleanup=()=>life.abort();const on={signal:life.signal};

    const type=v=>/^set/i.test(v.title)?'sets':/\d+pcs/i.test(v.title)?'multi':'single';

    const color=v=>/ash/i.test(v.title)?'ash':/walnut/i.test(v.title)?'walnut':'all';

    const label=v=>{if(type(v)==='sets'){const ash=v.title.match(/(\d+)\s*Ash/i)?.[1],walnut=v.title.match(/(\d+)\s*Walnut/i)?.[1];return ash&&walnut?`${ash} ${c.ash} + ${walnut} ${c.walnut}`:v.title.replace(/^set\s*/i,'');}const n=v.title.match(/(\d+)pcs/i)?.[1]||'1';return `${c[color(v)]} · ${n} ${n==='1'?c.light:c.lights}`;};

    let current=variants.find(v=>v.id===Number(select.value))||variants[0],group=type(current),finish='all',adding=false,imageToken=0;

    function updateImage(src,alt){

      const token=++imageToken,url=safeImage(src);if(!url)return;

      const preload=new Image();preload.onload=()=>{if(token!==imageToken)return;image.src=url;image.removeAttribute('srcset');image.alt=alt;zoom.querySelector('img').src=url;zoom.querySelector('img').alt=alt;};preload.src=url;

      $$('.gallery button',panel).forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.gallerySrc===src)));

    }

    function choose(v,fromClick=false){

      current=v;select.value=v.id;$('[data-price]',panel).textContent=money(v.price);

      const compare=$('[data-compare]',panel);compare.hidden=!(v.compare>v.price);if(!compare.hidden)compare.textContent=money(v.compare);

      $('[data-availability]',panel).textContent=v.available?config.available:config.soldOut;

      $('[data-variant-note]',panel).textContent=label(v);$('[data-add-label]',panel).textContent=v.available?config.add:config.soldOut;

      $('[name=add]',panel).disabled=!v.available;

      if(mobile){$('[data-mobile-price]',mobile).textContent=money(v.price);$('[data-mobile-add]',mobile).disabled=!v.available;}

      updateImage(panel.dataset.imageOverride||v.image,label(v));

      if(fromClick&&document.body.dataset.page==='product'){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}

      $$('.variant-grid button',panel).forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.id)===v.id)));

    }

    function render(){

      const list=variants.filter(v=>type(v)===group&&(finish==='all'||color(v)===finish));

      if(!list.some(v=>v.id===current.id)&&list.length)choose(list.find(v=>v.available)||list[0]);

      grid.replaceChildren();for(const v of list){

        const b=document.createElement('button');b.type='button';b.dataset.id=v.id;b.disabled=!v.available;b.setAttribute('aria-pressed',String(v.id===current.id));

        b.innerHTML=`<span>${escapeHTML(label(v))}</span><small>${escapeHTML(money(v.price))}</small>${v.id===current.id?`<span class="selected-label">${escapeHTML(c.selected)}</span>`:''}`;

        b.addEventListener('click',()=>{choose(v,true);render();},on);grid.append(b);

      }

      $$('[data-group]',panel).forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===group)));

      $$('[data-color]',panel).forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.color===finish)));

      $('.color-picker',panel).hidden=group==='sets';

    }

    $$('[data-group]',panel).forEach(b=>b.addEventListener('click',()=>{group=b.dataset.group;finish='all';render();},on));

    $$('[data-color]',panel).forEach(b=>b.addEventListener('click',()=>{finish=b.dataset.color;render();},on));

    $$('[data-gallery-src]',panel).forEach(b=>b.addEventListener('click',()=>updateImage(b.dataset.gallerySrc,b.dataset.galleryAlt),on));

    $('[data-zoom]',panel).addEventListener('click',()=>{zoom.showModal();modalState();},on);$('[data-zoom-close]',panel).addEventListener('click',()=>zoom.close(),on);zoom.addEventListener('close',modalState,on);

    select.addEventListener('change',()=>{const v=variants.find(v=>v.id===Number(select.value));if(v){group=type(v);choose(v,true);render();}},on);

    form.addEventListener('submit',async e=>{

      e.preventDefault();if(adding||!current.available)return;if(!form.reportValidity())return;

      const quantity=Number($('[name=quantity]',form).value);if(!Number.isInteger(quantity)||quantity<1||quantity>99)return;

      adding=true;const button=$('[name=add]',form),error=$('.form-error',panel);button.disabled=true;$('[data-add-label]',panel).textContent=config.adding;error.hidden=true;

      try{await api('cart/add.js',{items:[{id:current.id,quantity}]});toast(config.added);await openCart();}

      catch(err){error.textContent=err.message;error.hidden=false;}

      finally{adding=false;button.disabled=!current.available;$('[data-add-label]',panel).textContent=current.available?config.add:config.soldOut;}

    },on);

    if(mobile){$('[data-mobile-add]',mobile).addEventListener('click',()=>form.requestSubmit(),on);

      const obs=new IntersectionObserver(entries=>{const b=entries[0].boundingClientRect;mobile.hidden=b.bottom>0||entries[0].isIntersecting;},{threshold:0});obs.observe($('.buy-row',panel));life.signal.addEventListener('abort',()=>obs.disconnect(),{once:true});}

    select.hidden=true;$('.native-variant-label',panel).hidden=true;$('.enhanced-controls',panel).hidden=false;panel.classList.add('is-enhanced');choose(current);render();

  }

  function init(scope=document){

    $$('[data-review-grid]',scope).forEach(grid=>{if(grid.dataset.initialized)return;grid.dataset.initialized='true';const cards=$$('.review-card',grid),button=grid.parentElement.querySelector('[data-more-reviews]');let count=6;const show=()=>{cards.forEach((card,i)=>card.hidden=i>=count);button.hidden=count>=cards.length;};button.addEventListener('click',()=>{count+=6;show();},{signal});show();});

    const hash=location.hash;if(hash.startsWith('#ReviewForm-')){const form=document.getElementById(hash.slice(1));if(form)form.open=true;}

    $$('.review-form',scope).forEach(form=>{if(form.querySelector('.form-status,.errors'))form.open=true;});


    $$('[data-product-panel]',scope).forEach(initPanel);

    $$('[data-films]',scope).forEach(data=>{if(data.dataset.initialized)return;data.dataset.initialized='true';const section=data.closest('section'),v=$('video',section),films=JSON.parse(data.textContent);$$('[data-film]',section).forEach(button=>button.addEventListener('click',()=>{v.pause();v.src=films[Number(button.dataset.film)].url;v.poster=films[Number(button.dataset.film)].poster;v.load();$$('[data-film]',section).forEach(b=>b.setAttribute('aria-pressed',String(b===button)));},{signal}));});

    $$('[data-space-copy]',scope).forEach(data=>{if(data.dataset.initialized)return;data.dataset.initialized='true';const section=data.closest('section'),c=JSON.parse(data.textContent);$$('[data-space]',section).forEach(button=>button.addEventListener('click',()=>{const key=button.dataset.space;$('.room-stage',section).dataset.room=key;$('[data-space-description]',section).textContent=c[key].description;$('[data-space-name]',section).textContent=c[key].name;$$('[data-space]',section).forEach(b=>b.setAttribute('aria-pressed',String(b===button)));document.dispatchEvent(new CustomEvent('luma:space',{detail:{key,stage:$('[data-lamp-stage]',section)}}));},{signal}));});

    $$('[data-tilt]',scope).forEach(el=>{if(el.dataset.tiltReady)return;el.dataset.tiltReady='true';el.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse'||!motion())return;const b=el.getBoundingClientRect(),x=(e.clientX-b.left)/b.width-.5,y=(e.clientY-b.top)/b.height-.5;el.style.transform=`perspective(1100px) rotateX(${-y*3}deg) rotateY(${x*4}deg)`;},{passive:true,signal});el.addEventListener('pointerleave',()=>el.style.transform='',{signal});});

    $$('[data-reveal]',scope).forEach(el=>reveals.observe(el));schedule();

  }

  const reveals=new IntersectionObserver(entries=>entries.forEach(e=>{if(!e.isIntersecting)return;reveals.unobserve(e.target);if(motion())e.target.animate([{opacity:0,transform:'translateY(26px)'},{opacity:1,transform:'none'}],{duration:650,easing:'cubic-bezier(.2,.8,.2,1)'});}),{threshold:.06});

  function scroll(){

    scrollFrame=0;const vh=innerHeight;

    $$('[data-scroll-scene]').forEach(el=>{const r=el.getBoundingClientRect();const pin=el.querySelector('.hero,.opening-sticky,.story-grid,.process-layout,.spaces');if(!pin)return;const offset=parseFloat(getComputedStyle(pin).top)||0;const p=motion()?Math.max(0,Math.min(1,(offset-r.top)/Math.max(1,r.height-pin.clientHeight))):0;el.style.setProperty('--progress',p);if(el.classList.contains('opening-scroll')){const s=$('[data-scene-step]',el),c=$('[data-scene-caption]',el),step=p<.3?0:p<.65?1:2;s.textContent=`0${step+1} / 03`;const translations={0:config.mountStep,1:config.liftStep,2:config.glowStep};c.textContent=translations[step];}});
    if(motion())$$('.ambient-section').forEach(el=>{const r=el.getBoundingClientRect();if(r.bottom>0&&r.top<vh){el.style.setProperty('--ambient-y',`${Math.max(-100,Math.min(100,(vh/2-r.top)*.1))}px`);el.style.setProperty('--sun-angle',`${(vh/2-r.top)*.03}deg`);}});

    if(document.body.dataset.page==='index'){

      let key='home';for(const id of ['details']){const r=$('#'+id)?.getBoundingClientRect();if(r&&r.top<vh*.4&&r.bottom>vh*.3)key=id;}

      $$('.glass-nav [data-nav-key]').forEach(a=>{if(a.dataset.navKey===key)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});

    }

    document.dispatchEvent(new CustomEvent('luma:scroll'));

  }

  function schedule(){if(!scrollFrame&&!document.hidden)scrollFrame=requestAnimationFrame(scroll);}

  window.addEventListener('scroll',schedule,{passive:true,signal});window.addEventListener('resize',schedule,{passive:true,signal});

  const cursor=$('.luma-cursor');

  if(matchMedia('(hover:hover) and (pointer:fine)').matches&&!reduced.matches){

    let x=0,y=0,rx=0,ry=0,frame=0;

    const draw=()=>{rx+=(x-rx)*.2;ry+=(y-ry)*.2;$('i',cursor).style.transform=`translate(${rx}px,${ry}px)`;$('b',cursor).style.transform=`translate(${x}px,${y}px)`;$('span',cursor).style.transform=`translate(${rx}px,${ry}px)`;frame=Math.abs(x-rx)+Math.abs(y-ry)>.3?requestAnimationFrame(draw):0;};

    document.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse'||reduced.matches)return;x=e.clientX;y=e.clientY;if(cursor.hidden){rx=x;ry=y;cursor.hidden=false;document.documentElement.classList.add('cursor-ready');}cursor.dataset.hover=!!e.target.closest('a,button,summary,[data-explore]');if(!frame)frame=requestAnimationFrame(draw);},{passive:true,signal});

    document.addEventListener('pointerdown',()=>cursor.dataset.pressed='true',{signal});document.addEventListener('pointerup',()=>cursor.dataset.pressed='false',{signal});document.addEventListener('pointerleave',()=>{cursor.hidden=true;document.documentElement.classList.remove('cursor-ready');},{signal});

    signal.addEventListener('abort',()=>cancelAnimationFrame(frame),{once:true});

  }

  reduced.addEventListener('change',()=>{if(reduced.matches){cursor.hidden=true;document.documentElement.classList.remove('cursor-ready');$$('[data-tilt]').forEach(el=>el.style.transform='');}schedule();},{signal});

  let shown=false;const born=performance.now();function revealLoader(){if(shown)return;shown=true;setTimeout(()=>document.documentElement.classList.remove('luma-loading'),Math.max(0,650-(performance.now()-born)));}

  document.addEventListener('luma:world-ready',revealLoader,{once:true,signal});setTimeout(revealLoader,2800);

  document.addEventListener('shopify:section:load',e=>init(e.target),{signal});document.addEventListener('shopify:section:unload',e=>$$('[data-product-panel]',e.target).forEach(p=>p.lumaCleanup?.()),{signal});

  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();},{signal});

  window.addEventListener('pagehide',e=>{if(e.persisted)return;events.abort();reveals.disconnect();cancelAnimationFrame(scrollFrame);$$('[data-product-panel]').forEach(p=>p.lumaCleanup?.());clearTimeout(toastTimer);},{once:true});

  init();

})();



